// View Management Action Types
export const OPEN_VIEW_DRAWER = 'OPEN_VIEW_DRAWER';
export const CLOSE_VIEW_DRAWER = 'CLOSE_VIEW_DRAWER';
export const SET_CURRENT_VIEW = 'SET_CURRENT_VIEW';
export const SET_DEFAULT_VIEW = 'SET_DEFAULT_VIEW';
export const SET_DEFAULT_VIEW_START = 'SET_DEFAULT_VIEW_START';
export const SET_DEFAULT_VIEW_FAILURE = 'SET_DEFAULT_VIEW_FAILURE';
export const OPEN_VIEW_DIALOG = 'OPEN_VIEW_DIALOG';
export const CLOSE_VIEW_DIALOG = 'CLOSE_VIEW_DIALOG';
export const SET_DIALOG_TYPE = 'SET_DIALOG_TYPE';
export const SET_DIALOG_SUBTYPE = 'SET_DIALOG_SUBTYPE';

// View CRUD Action Types
export const SAVE_VIEW_START = 'SAVE_VIEW_START';
export const SAVE_VIEW_SUCCESS = 'SAVE_VIEW_SUCCESS';
export const SAVE_VIEW_FAILURE = 'SAVE_VIEW_FAILURE';
export const DELETE_VIEW_START = 'DELETE_VIEW_START';
export const DELETE_VIEW_SUCCESS = 'DELETE_VIEW_SUCCESS';
export const DELETE_VIEW_FAILURE = 'DELETE_VIEW_FAILURE';
export const RENAME_VIEW_START = 'RENAME_VIEW_START';
export const RENAME_VIEW_SUCCESS = 'RENAME_VIEW_SUCCESS';
export const RENAME_VIEW_FAILURE = 'RENAME_VIEW_FAILURE';
export const FETCH_VIEWS_START = 'FETCH_VIEWS_START';
export const FETCH_VIEWS_SUCCESS = 'FETCH_VIEWS_SUCCESS';
export const FETCH_VIEWS_FAILURE = 'FETCH_VIEWS_FAILURE';
export const EDIT_VIEW_START = 'EDIT_VIEW_START';
export const EDIT_VIEW_SUCCESS = 'EDIT_VIEW_SUCCESS';
export const EDIT_VIEW_FAILURE = 'EDIT_VIEW_FAILURE';

// Clear alerts
export const CLEAR_VIEW_MANAGEMENT_ALERTS = 'CLEAR_VIEW_MANAGEMENT_ALERTS';

// Selection actions
export const SET_SELECTED_VIEW_FOR_EDIT = 'SET_SELECTED_VIEW_FOR_EDIT';
export const SET_SELECTED_VIEWS = 'SET_SELECTED_VIEWS';
export const CLEAR_SELECTED_VIEWS = 'CLEAR_SELECTED_VIEWS';


export const SYSTEM_DEFAULT_VIEW_NAME = 'System Default View';
export const SYSTEM_DEFAULT_VIEW_TYPE = 'system_default';

// List management actions
export const SET_SITE_LIST = 'SET_SITE_LIST';
export const SET_NO_ACCESS_SITE_LIST = 'SET_NO_ACCESS_SITE_LIST';
export const SET_COST_CENTER_LIST = 'SET_COST_CENTER_LIST';
export const SET_QUICK_LINK_CONTACTS_LIST = 'SET_QUICK_LINK_CONTACTS_LIST';
export const CLEAR_ALL_LISTS = 'CLEAR_ALL_LISTS';
export const FETCH_PRIMARY_LIST_DATA_START = 'FETCH_PRIMARY_LIST_DATA_START';
export const FETCH_PRIMARY_LIST_DATA_SUCCESS = 'FETCH_PRIMARY_LIST_DATA_SUCCESS';
export const FETCH_PRIMARY_LIST_DATA_FAILURE = 'FETCH_PRIMARY_LIST_DATA_FAILURE';

// Filtered list management actions
export const SET_FILTERED_SITE_LIST = 'SET_FILTERED_SITE_LIST';
export const SET_FILTERED_COST_CENTER_LIST = 'SET_FILTERED_COST_CENTER_LIST';
export const CLEAR_ALL_FILTERED_LISTS = 'CLEAR_ALL_FILTERED_LISTS';

// Default filtered list management actions (for API provided data)
export const SET_DEFAULT_FILTERED_SITE_LIST = 'SET_DEFAULT_FILTERED_SITE_LIST';
export const SET_DEFAULT_FILTERED_COST_CENTER_LIST = 'SET_DEFAULT_FILTERED_COST_CENTER_LIST';
export const CLEAR_ALL_DEFAULT_FILTERED_LISTS = 'CLEAR_ALL_DEFAULT_FILTERED_LISTS';
export const SET_VIEW_AND_USER_CONFIG_READY = 'SET_VIEW_AND_USER_CONFIG_READY';

// Dialog Types
export const DIALOG_TYPES = {
  EDIT: 'edit',
  SAVE_AS: 'saveAs',
  RENAME: 'rename',
  DELETE: 'delete'
};

export const DIALOG_SUBTYPES = {
  SYSTEM_DEFAULT: 'systemDefault',
  CUSTOM: 'custom',
  EDIT_PRIMARY_LIST: 'editPrimaryList',
  EDIT_SITE_LIST: 'editSiteList',
  EDIT_COST_CENTER_LIST: 'editCostCenterList'
};